import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { NonAlcoholicDrinkType } from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { NonAlcoholicDrinkProperties } from '@app/api/marketplace/models';

import { CocktailSyrupPropertiesSubformComponent } from '../cocktail-syrup/cocktail-syrup-properties-subform/cocktail-syrup-properties-subform';
import { CoffeePropertiesSubformComponent } from '../coffee/coffee-properties-subform/coffee-properties-subform.component';
import { EnergyDrinkPropertiesSubformComponent } from '../energy-drink/energy-drink-properties-subform/energy-drink-properties-subform.component';
import { JuicePropertiesSubformComponent } from '../juice/juice-properties-subform/juice-properties-subform.component';
import { MineralWaterPropertiesSubformComponent } from '../mineral-water/mineral-water-properties-subform/mineral-water-properties-subform.component';
import { SoftDrinkPropertiesSubformComponent } from '../soft-drink/soft-drink-properties-subform/soft-drink-properties-subform.component';
import { SyrupPropertiesSubformComponent } from '../syrup/syrup-properties-subform/syrup-properties-subform.component';
import { TeaPropertiesSubformComponent } from '../tea/tea-properties-subform/tea-properties-subform.component';

@Component({
  selector: 'app-non-alcoholic-drink-properties-subform',
  templateUrl: './non-alcoholic-drink-properties-subform.component.html',
  styleUrls: ['./non-alcoholic-drink-properties-subform.component.scss'],
})
export class NonAlcoholicDrinkPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.NON_ALCOHOLIC_DRINK_PROPERTIES';

  static buildForm(
    fb: FormBuilder,
    selectedType: NonAlcoholicDrinkType,
    data: NonAlcoholicDrinkProperties | undefined,
    // @ts-ignore: noUnusedLocals (it will likely be used in the future)
    isSecondaryProductSheet: boolean
  ) {
    return fb.group({
      ...(selectedType == NonAlcoholicDrinkType.CocktailSyrup && {
        cocktailSyrupProperties:
          CocktailSyrupPropertiesSubformComponent.buildForm(
            fb,
            data?.cocktailSyrupProperties
          ),
      }),
      ...(selectedType == NonAlcoholicDrinkType.Coffee && {
        coffeeProperties: CoffeePropertiesSubformComponent.buildForm(
          fb,
          data?.coffeeProperties
        ),
      }),
      ...(selectedType == NonAlcoholicDrinkType.EnergyDrink && {
        energyDrinkProperties: EnergyDrinkPropertiesSubformComponent.buildForm(
          fb,
          data?.energyDrinkProperties
        ),
      }),
      ...(selectedType == NonAlcoholicDrinkType.IceTea && {
        iceTeaProperties: SoftDrinkPropertiesSubformComponent.buildForm(
          fb,
          data?.iceTeaProperties
        ),
      }),
      ...(selectedType == NonAlcoholicDrinkType.FruitOrVegetableJuice && {
        juiceProperties: JuicePropertiesSubformComponent.buildForm(
          fb,
          data?.juiceProperties
        ),
      }),
      ...(selectedType == NonAlcoholicDrinkType.MineralWater && {
        mineralWaterProperties:
          MineralWaterPropertiesSubformComponent.buildForm(
            fb,
            data?.mineralWaterProperties
          ),
      }),
      ...(selectedType == NonAlcoholicDrinkType.SodaPop && {
        sodaPopProperties: SoftDrinkPropertiesSubformComponent.buildForm(
          fb,
          data?.sodaPopProperties
        ),
      }),
      ...(selectedType == NonAlcoholicDrinkType.Syrup && {
        syrupProperties: SyrupPropertiesSubformComponent.buildForm(
          fb,
          data?.syrupProperties
        ),
      }),
      ...(selectedType == NonAlcoholicDrinkType.TeaOrMedicinalTea && {
        teaProperties: TeaPropertiesSubformComponent.buildForm(
          fb,
          data?.teaProperties
        ),
      }),
    });
  }
}
